<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col-md-4">
            <h3 class="page-title">Gəlir və Xərc hesabat</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/dashboard/admin-dashboard"
                  >Daşbord</router-link
                >
              </li>
              <li class="breadcrumb-item active">Gəlir və Xərc</li>
            </ul>
          </div>
          <div class="col-md-8 float-end ms-auto">
            <div class="d-flex title-head">
              <div class="view-icons">
                <a
                  href="javascript:void(0);"
                  class="grid-view btn btn-link"
                  v-tippy
                  title="Filtri sıfırla"
                  @click="resetSearchFilter"
                  ><i class="las la-redo-alt"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="list-view btn btn-link"
                  id="collapse-header"
                  v-tippy
                  title="Tam ekran"
                  @click="toggleFullscreen"
                  ><i class="las la-expand-arrows-alt"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="list-view btn btn-link"
                  id="filter_search"
                  v-tippy
                  title="Filterlər"
                  v-on:click="filter = !filter"
                  :class="{ setclose: filter }"
                  ><i class="las la-filter"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <!-- Search Filter -->
      <search-area
        :filter="filter"
        ref="searchComponent"
        :searchFilters="searchFilters"
        @submitSearchFilter="searchFilterSubmitHandler"
      ></search-area>
      <hr />
      <!-- /Search Filter -->
      <div class="filter-section mb-3">
        <ul>
          <li>
            <form @submit.prevent="searchSubmit">
              <div class="search-set">
                <div class="search-input">
                  <a
                    href="javascript:void(0);"
                    @click="searchSubmit"
                    class="btn btn-searchset"
                    ><i class="las la-search"></i
                  ></a>
                  <div class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder="Axtar"
                        v-model="searchString"
                    /></label>
                  </div>
                </div>
              </div>
            </form>
          </li>
        </ul>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <a-table
              class="stripped table-hover"
              :columns="columns"
              :data-source="data"
              :pagination="false"
              @change="handleTableChange"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'company'">
                  {{ record.company?.name }}
                </template>
              </template>
            </a-table>
            <a-pagination
              :current="currentPage"
              :total="totalData"
              :page-size="pageSize"
              @change="handlePageChange"
              class="mt-3 text-end mb-5"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script setup>
import { ref, onMounted, reactive, onBeforeUnmount, watch } from "vue";

import {
  handleTableSorterChange,
  showErrorToast,
  toggleViewFullscreen,
} from "@/utils/helper";
import { useReportsStore } from "@/stores/modules/reports";

// Store
const reportStore = useReportsStore();

// State
const data = ref([]);

// Pagination and Filters
const filter = ref(true);
const searchComponent = ref(null);
let searchString = ref("");
let searchFiltersValue = reactive({});
let currentPage = ref(1);
let pageSize = ref(15);
let totalData = ref(0);

const sortParams = ref({
  sortField: "id",
  sortOrder: "desc",
});

// Columns
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: true,
  },
  {
    title: "Şirkət",
    dataIndex: "company_name",
    key: "company",
    sorter: false,
  },
  {
    title: "Hesab",
    dataIndex: "name",
    sorter: false,
  },
  {
    title: "Alacaq (AZN)",
    dataIndex: "receive_amount",
    sorter: false,
  },
  {
    title: "Verəcək (AZN)",
    dataIndex: "be_paid_amount",
    sorter: false,
  },
  {
    title: "Gəlir (AZN)",
    dataIndex: "income_amount",
    sorter: false,
  },
  {
    title: "Xərclər (AZN)",
    dataIndex: "expense_amount",
    sorter: false,
  },
  {
    title: "Toplam gəlir (AZN)",
    dataIndex: "total_income_amount",
    sorter: false,
  },
  {
    title: "Toplam xərc (AZN)",
    dataIndex: "total_expense_amount",
    sorter: false,
  },
];

//Filters
const searchFilters = ref([
  {
    title: "Tarix",
    key: "date",
    type: "singleDate",
    class: "col-xl-4",
    required: true,
  },
]);

/* -------------------- Methods -------------------- */

// Fetch data with pagination
const fetchListData = async (
  page = 1,
  searchString = "",
  searchFilters = searchFiltersValue
) => {
  try {
    const response = await reportStore.getSummary({
      params: {
        offset: (page - 1) * pageSize.value,
        limit: pageSize.value,
        q: searchString,
        sortField: sortParams.value.sortField,
        sortOrder: sortParams.value.sortOrder,
        ...searchFilters,
      },
    });
    const responseData = response.data;
    data.value = responseData.data;
    totalData.value = responseData.total;
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

// Search items
const searchSubmit = async () => {
  fetchListData(1, searchString.value);
};

// Search Filters Submit
const searchFilterSubmitHandler = async (filters) => {
  const requiredKeys = searchFilters.value
    .filter((filter) => filter.required)
    .map((filter) => filter.key);

  const hasAllRequiredKeys = requiredKeys.every(
    (key) =>
      key in filters &&
      filters[key] !== null &&
      filters[key] !== undefined &&
      filters[key] !== ""
  );

  if (!hasAllRequiredKeys) {
    showErrorToast("Tarix qeyd olunmalıdır");
    return;
  }

  await fetchListData(1, null, filters);
  searchFiltersValue = filters;
};

const resetSearchFilter = async () => {
  // await fetchListData();
  searchComponent.value.resetFilters();
  data.value = [];
};

// Handle page change for pagination
const handlePageChange = (page) => {
  currentPage.value = page;
  fetchListData(page);
};

// Handle Table Changes (Sorting)
const handleTableChange = async (pagination, filters, sorter) => {
  await handleTableSorterChange(sorter, sortParams);
  fetchListData(currentPage.value);
};

const toggleFullscreen = () => toggleViewFullscreen();

/* -------------------- Lifecycle Hooks -------------------- */

const debounceTime = 500;

let debounceTimeout;

watch(searchString, () => {
  if (debounceTimeout) clearTimeout(debounceTimeout);

  debounceTimeout = setTimeout(() => {
    searchSubmit();
  }, debounceTime);
});

// On component mount
onMounted(() => {});

// Before unmount
onBeforeUnmount(() => {
  // document.removeEventListener("click", handleDocumentClick);
});
</script>
    
    <style>
.ant-pagination-item a {
  color: black !important;
}

.ant-pagination-item-active a {
  color: white !important;
}
</style>
    